import { useEffect, useState } from "react";
import DataTable from "../../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const deleteEndpoint = ApiEndpoints.product.delete;
const listEndpoint = ApiEndpoints.product.list;
const editPath = "edit-product";
const tableHeader = ["Name", "category", "Brand" , "Model Number", "Capacity" , "Type" , "No of Rolls"];
const tbody = ["title", "category_name", "brand" , "model_number" , "capacity" , "type", "no_of_rolls_and_roll_dia"];

export default function ProductsListing() {
  const [data, setData] = useState([]);
  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", listEndpoint);
      const result = response.products;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (product_id) => {
      const payload = { product_id };
      try {
        const response = await ApiRequest("POST", deleteEndpoint, payload);
        toast.success(response.message)
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    };

    const pagename = {
      name: 'Product Management',
      user: 'Admin',
      innerpage: 'Product Management / Product'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-product">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={editPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
